module.exports = __webpack_public_path__ + "img/jobs.106f9b57.svg";